import 'babel-polyfill';
import 'core-js';
import 'mutation-observer';
import './polyfill';
import  'react-app-polyfill/ie11';
import  'react-app-polyfill/stable';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import {Switch,Route} from 'react-router';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './components/App';
import Home from './components/Home/home';
import AboutJingWei from './components/About/About';
import BussinessScope from './components/BussinessScope/businessScope';
import AboutPolicy from './components/AboutPolicy/AboutPolicy';
import FocusNews from './components/FocusNews/FocusNews';
import Recruitment from './components/Recruitment/recruitment';
import TechFinance from './components/TechFinance/TechFinance';
import ContactUs from './components/ContactUs/ContactUs';
import PolicyMore from './components/AboutPolicy/PolicyMore';
import InterestSearch from './components/InterestSearch/interestSearch';
import SearchResult from './components/SearchResult/SearchResult';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import  appStore from './store/AppStore';

const preloadState={

}

const store=appStore(preloadState);

ReactDOM.render(
  <Provider store={store} >
    <BrowserRouter>
      <App>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/home" component={Home}/>

          <Route exact path="/about/:cateId?/:title?" component={AboutJingWei}/>

          <Route path="/bussiness/:id?" component={BussinessScope}/>

          <Route exact path="/policy" component={AboutPolicy}/>
          <Route exact path="/policy/more/:cateId/:title" component={PolicyMore} />
          <Route path="/policy/more/:cateId/:title/detail/:id?" component={PolicyMore}/>

          <Route exact path="/news" component={FocusNews} />
          <Route path="/news/detail/:id" component={FocusNews} />

          <Route exact path="/techFinance" component={TechFinance}/>
          <Route path="/techFinance/detail/:id" component={TechFinance} />

          <Route path="/interest-search/:interestId/:title" component={InterestSearch} />

          <Route path="/recruitment" component={Recruitment}/>
          <Route path="/recruitment#contact-us" component={ContactUs}/>

          <Route path="/searchResult/:searchKeys" component={SearchResult}/>
          <Route path="/searchResult/detail/:tab/:id" component={SearchResult} />
        </Switch>
      </App>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
